<template>
  <!-- 正在下载 -->
  <div>
      <div @click="abc">333</div>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
    }
  },
  created(){
  },
  mounted(){
        this.abc()
  },
  methods:{
      abc(){
        if(global.getmobiletype()=="android"){
            window.open(global.AndroidStore)
        }
        else{ 
            window.open(global.IosStore)  
        }
      }
  }
}
</script>






// WEBPACK FOOTER //
// src/components/download.vue